import store from '@/store'
import { EmailVerificationKey, VerifyEmailParams } from './types'

/**
 * メール認証URLかどうかをquery(key, expires, signature)を保持してるかで判断する
 */
export const hasVerifyEmailQuery = (
  params: Partial<VerifyEmailParams & { key: EmailVerificationKey }>
): boolean => {
  return (
    params.hasOwnProperty('key') &&
    params.hasOwnProperty('expires') &&
    params.hasOwnProperty('signature')
  )
}

export const isVerifiedUser = (): boolean => {
  return store.getters['auth/emailVerified']
}

export const castVerifyEmailParams = ({
  key,
  expires,
  signature,
}: {
  key: any
  expires: any
  signature: any
}): VerifyEmailParams & { key: EmailVerificationKey } => {
  return {
    key: Number(key),
    expires: Number(expires),
    signature: String(signature),
  }
}
